import React from 'react';
import Icon from '../../../components/AppIcon';

const TextInput = ({ value, onChange }) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Icon name="Type" size={18} color="var(--color-accent)" strokeWidth={2} />
        <label className="text-sm font-caption font-medium text-foreground">
          Enter Your Text
        </label>
      </div>
      <textarea
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder="Type or paste your text here..."
        rows={6}
        className="w-full px-4 py-3 rounded-lg border border-input bg-background text-foreground dark:text-white text-sm font-body resize-none focus:outline-none focus:ring-2 focus:ring-ring transition-smooth"
      />
      <div className="flex items-center justify-between text-xs font-caption text-muted-foreground">
        <span>{value?.length} characters</span>
        <span>Max recommended: 500 characters</span>
      </div>
    </div>
  );
};

export default TextInput;